<template>
  <nav class="bg-white flex items-center justify-between border py-0.5" aria-label="Pagination">
    <div>
      <button class="pagination-btn" @click="prev" :class="classDisablePrev" data-cy="prev">
        {{ $t('paging.prev') }}
      </button>
    </div>
    <div>
      <el-select
        v-model="defaultRows"
        class="w-20 lg:w-28"
        size="medium"
        @change="selectRows"
        data-cy="selectRows"
      >
        <el-option
          v-for="item in listRows"
          :key="item"
          :label="$t('paging.rows', { rows: item })"
          :value="item"
        />
      </el-select>
    </div>
    <div>
      <button class="pagination-btn" @click="next" :class="classDisableNext" data-cy="next">
        {{ $t('paging.next') }}
      </button>
    </div>
  </nav>
</template>

<script lang="ts">
import { computed, defineComponent, ref } from 'vue'
import { DEFAULT_PAGE_ROWS } from 'core/constants'

export default defineComponent({
  name: 'Pagination',
  props: {
    totalPage: {
      type: Number,
      default: 1,
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    selectedRows: {
      type: Number,
      default: DEFAULT_PAGE_ROWS,
    },
  },
  setup(_, ctx) {
    const defaultRows = ref(_.selectedRows)
    const listRows = ref([5, 10, 20, 25, 50, 100])

    const prev = () => {
      if (_.currentPage === 1) return
      ctx.emit('changePage', _.currentPage - 1)
    }

    const next = () => {
      ctx.emit('changePage', _.currentPage + 1)
    }

    const selectRows = () => {
      ctx.emit('rows', defaultRows.value)
    }

    const classDisablePrev = computed(() => {
      return _.currentPage > 1
        ? 'bg-gray-200 hover:bg-gray-400 hover:text-white'
        : 'bg-slate-50 opacity-50 pointer-events-none'
    })

    const classDisableNext = computed(() => {
      return _.currentPage === _.totalPage
        ? 'bg-slate-50 opacity-50 pointer-events-none'
        : 'bg-gray-200 hover:bg-gray-400 hover:text-white'
    })

    return {
      prev,
      next,
      listRows,
      selectRows,
      defaultRows,
      classDisablePrev,
      classDisableNext,
    }
  },
})
</script>
<style lang="scss" scoped>
.pagination-btn {
  @apply transition ease-in-out delay-100 rounded inline-flex items-center px-6 md:px-40 lg:px-52 py-1.5 mx-0.5 border border-gray-300 text-sm font-medium text-gray-500 cursor-pointer;
}
</style>
